import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { springVariants, springViewport } from '../utils/framerVariants';

const InternalVideo = ({ data }) => {
  useEffect(() => {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      const Plyr = require('plyr');
      const setupPlayer = () => {
        const player = new Plyr('.allianz-player-single', {
          iconUrl: "/plyr.svg",
          controls: [
            'play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'pip', 'airplay', 'fullscreen'
          ],
          captions: {
            active: true,
            language: 'en',
            update: true
          },
        });
        return player;
      };

      const player = setupPlayer();
      return () => player.destroy();
    }
  }, []);

  const videoPoster = data.Cover && data.Cover.file ? data.Cover.file.url : undefined;
  const videoSource = data.Video && data.Video.file ? data.Video.file.url : undefined;

  return (
    <motion.article variants={springVariants} initial="invisible" whileInView="visible" viewport={springViewport} className="container mx-auto max-w-6xl lg:max-w-7xl 2xl:max-w-8xl mb-16 md:mb-24 lg:mb-32 xl:mb-48 px-4 md:px-24 lg:px-24 xl:px-24">
      <video crossOrigin="true" className="allianz-player-single" poster={videoPoster}>
        {videoSource && (
          <source src={videoSource} type="video/mp4" />
        )}
        {data.Subtitle && data.Subtitle.file && data.Subtitle.file.url && (
          <track kind="captions" label="English" srclang="en" src={data.Subtitle.file.url} default="true" />
        )}
      </video>
      {(data.videoCaption || (data.Video && data.Video.caption)) && (
        <p className="caption-rich-text" dangerouslySetInnerHTML={{ __html: data.videoCaption ? data.videoCaption : data.Video.caption }} />
      )}

    </motion.article>
  );
}

export default InternalVideo;
